'use strict';
import SessionManager from '../Manager/Session.manager'

export class Channel {
    constructor(data) {
        this.channel_id = ''
        this.channel_name = ''
        this.channel_purpose = ''
        this.created = 0
        this.modified = 0
        this.creator_id = ''
        this.total_msg_count = 0
        this.user_ids = []
        this.type = 'channel'
        this.content = []
        this.deleted = false
        this.has_unread_msgs = false
        this.flag = ''
        this.direct = false
        this.stared_users = []
        this.restore_users = []
        this.loggedinStar = false
        this.sqn = 0
        this.admin = false
        this.first_unread_post_sqn = 0
        this.removed_users = []
        this.external = false
        this.public = false
        this.last_message = null
        this.latest_message_at = null
        this.unread_count = 0
        this.image_db = null
        this.image_doc = null


        if (typeof data != 'undefined' && data != null) {
            this.channel_id = data.channel_id
            this.channel_purpose = data.channel_purpose
            this.created = data.created
            this.modified = data.modified
            this.deleted = data.deleted
            this.creator_id = data.creator_id
            this.total_msg_count = data.total_msg_count
            this.direct = data.direct
            this.stared_users = data.stared_users
            this.restore_users = data.restore_users
            this.sqn = data.sqn
            this.first_unread_post_sqn = data.first_unread_post_sqn
            this.admin = data.admin
            this.has_unread_msgs = data.has_unread_msgs

            if (typeof data.user_ids != 'undefined' && data.user_ids != '') {
                this.user_ids = data.user_ids
            }

            if (typeof data.channel_name != 'undefined' && data.channel_name != '') {
                this.channel_name = data.channel_name
            }

            if (typeof data.folder_name != 'undefined' && data.folder_name != '') {
                this.channel_name = data.folder_name
            }

            if (typeof data.public != 'undefined') {
                this.public = data.public
            }

            if (typeof data.removed_users != 'undefined') {
                this.removed_users = data.removed_users
            }

            /** Direct Message */
            if (this.direct) {
                if (this.channel_id == SessionManager.getLoggedInUserId()) {
                    this.type = "draft"
                }

                this.reachability = 'offline'
                if (typeof data.external != 'undefined') {
                    this.external = data.external
                }
            }

            if(data.image_doc != null && typeof data.image_doc.valueb64 != 'undefined'){
                this.image_db = data.image_doc
                this.image_doc = "data"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                if(data.image_doc.mimetype.indexOf(":")== -1){
                    this.image_doc = "data:"+data.image_doc.mimetype+";base64," + data.image_doc.valueb64
                }
            }

            if (typeof data.other_user_id != "undefined") {
                this.other_user_id = data.other_user_id
            }

            if (typeof data.type != 'undefined') {
                this.type = data.type
            }

            if (typeof data.cp_id != 'undefined') {
                this.channel_id = data.cp_id
                this.channel_name = data.name
                this.channel_purpose = ''
                this.type = 'folder'
            }

            //*Invitation Create*/
            if (typeof data.invitations != 'undefined') {
                this.invitations = data.invitations
            }

            if (typeof data.invitation_id != 'undefined') {
                if (typeof data.folder_cp_id != "undefined") {
                    this.channel_id = data.folder_cp_id
                }

                if (typeof data.channel_id != "undefined") {
                    this.channel_id = data.channel_id
                }
                // if(typeof data.channel_name != "undefined"){
                //   this.channel_name = data.channel_name
                // }
                if(!this.channel_name && typeof data.folder_name != "undefined"){
                  this.channel_name = data.folder_name
                }

                this.channel_purpose = data.channel_purpose
                this.invitation_id = data.invitation_id

                if (typeof data.publish_user_cp_id != 'undefined') {
                    this.creator_id = data.publish_user_cp_id
                    this.publish_user_cp_id = data.publish_user_cp_id
                    this.user_ids = [data.user_cp_id, data.publish_user_cp_id]
                }
                if (this.creator_id != SessionManager.getLoggedInUserId()) {
                    this.type = 'invitation'
                }
            }

            // stared loggedin user
            if (typeof this.stared_users != 'undefined' &&
                this.stared_users.indexOf(SessionManager.getLoggedInUser().user_id) > -1) {

                this.loggedinStar = true
            } else {
                this.loggedinStar = false
            }

            if (this.channel_name == 'CloudBot' || this.channel_name == 'Feedback') {
                this.reachability = 'online';
            }

            if (data.latest_message_at) {
                this.latest_message_at = data.latest_message_at;
            }

            if (data.hasOwnProperty('unread_count')) {
                this.unread_count = data.unread_count;
            }
        }
    }
}
